import styled from 'styled-components';
import checkedIconGrey from '../../assets/checkedGrey.svg';
import checkedIconWhite from '../../assets/checkedWhite.svg';
import { Flex } from '../../utilities/GlobalStyle';
import { devices } from '../../utilities/responsive';

export const Form = styled.form`
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px;
    background: var(--white);
    border-radius: 8px;
    margin: -230px auto;
    position: sticky;
    top: 100px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .15);
    
    & > * {
        input {
            font-family: "Nunito Sans", sans-serif;
        }
    }

    button {
        background: linear-gradient(to right, #654AD2 0%, #2173CF 40%, #247CCC 49%, #36B1BD 100%);
        background-size: 120%;
        transition: background .3s ease;

        &:hover {
            background-position: 100% 0;
        }
    }

    @media ${devices.desktopLg} {
        margin: -116px auto;
    }

    @media ${devices.tabletLandscape} {
        margin: 64px auto;
        padding: 32px;
        width: 100%;

        img {
            display: none;
        }
    }

    @media ${devices.phoneSm} {
        padding: 16px;
    }

    img {
        margin-top: -250px;
    }

    .btn-continue {
        position: absolute;
        bottom: -36px;
        left: 50%;
        transform: translateX(-50%);
        padding: 16px 96px !important;
        display: flex;
        align-items: center;
        font-size: 18px !important;
        color: var(--white);
        border:none;
        border-radius:4px;
        font-family: "Nunito Sans", sans-serif;
    font-weight: 900;
        &:hover{
            cursor:pointer;
            background-position: 100% 0px;

        }


        @media ${devices.tabletLandscape} {
            padding: 16px 48px !important;
        }

        @media ${devices.phoneSm} {
            position: initial;
            bottom: 0;
            left: 0;
            transform: translateX(0);
            padding: 16px !important;
            width: 100% !important;
            justify-content: center;
        }

        svg {
            margin-right: 16px;
            width: 32px;
            height: 32px;
        }
    }
`;

export const InputWrapper = styled.div`
    position: relative;
    width: 100%;

    input[type="checkbox"] {
        & + label {
            display: block;
            margin-left: 16px;
            color: #707070;
            font-size: 12px;
            font-weight: 400;

            a {
                font-weight: 700;
            }
        }
    }

    &:not(:last-child) {
        margin-bottom: 32px;
    }

    .error {
        color: #D36565 !important;
        font-style: italic;
        font-size: 11px;
        font-weight: 400;
    }
`;

export const Input = styled.input<{
    $error?: boolean
}>`
    width: 100%;
    position: relative;
    padding: 16px;
    border-radius: 8px;
    background: #F7FAFC;
    color: var(--primary);
    border: 1px solid ${({ $error }) => $error ? 'red' : 'transparent'};
    transition: all .3s ease;

    &::placeholder {
        color: var(--primary);
        transition: all .2s ease;
    }

    &:not(:placeholder-shown) {
        & + label {
            top: -16%;
            font-size: 11px;
            font-weight: 400;
            color: var(--secondary-color);
        }
    }

    &:focus {
        outline: none;
        border: 1px solid ${({ $error }) => $error ? 'red' : 'var(--primary)'};
        background: var(--white);

        &::placeholder {
            transform: translateY(-210%);
        }

        & + label {
            top: -16%;
            font-size: 11px;
            font-weight: 400;
            color: var(--secondary-color);
        }
    }
`;

export const Textarea = styled.textarea<{
    $error?: boolean
}>`
    height: 240px;
    resize: none;
    width: 100%;
    position: relative;
    padding: 16px;
    border-radius: 8px;
    background: #F7FAFC;
    color: var(--primary);
    border: 1px solid ${({ $error }) => $error ? 'red' : 'transparent'};
    transition: all .3s ease;
    font-family:"Nunito-Sans", sans-serif;

    &::placeholder {
        color: var(--primary);
        transition: all .2s ease;
    }

    &:not(:placeholder-shown) {
        & + label {
            top: -5%;
            font-size: 12px;
            font-weight: 400;
            color: var(--secondary-color);
        }
    }

    &:focus {
        outline: none;
        border: 1px solid ${({ $error }) => $error ? 'red' : 'var(--primary)'};
        background: var(--white);

        &::placeholder {
            transform: translateY(-210%);
        }

        & + label {
            top: -5%;
            font-size: 12px;
            font-weight: 400;
            color: var(--secondary-color);
        }
    }
`;

export const Label = styled.label`
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    font-size: 16px;
    color: var(--primary);
    z-index: -1;
    transition: all .3s ease;
`;

export const SendCV = styled.input`
    width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
    z-index: -1;
`;

export const SendCVLabel = styled.label`
    display: flex;
    align-items: center;
    color: var(--primary);
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    align-items: center;

    svg {
        width: 16px;
        height: 16px;
        margin-right: 16px;
    }
`;

export const AcceptPolicyWrapper = styled(Flex)`
    flex-wrap: initial !important;
`;

export const AcceptPolicy = styled.input`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;

    &:checked {
        &::before {
            box-shadow: 0 0 0 1px var(--primary);
            background: var(--primary);
            background-image: url(${checkedIconWhite});
            background-size: 80% 80%;
            background-repeat: no-repeat;
            background-position: center;
        }
    }

    &::before {
        position: relative;
        display: block;
        width: 14px;
        height: 14px;
        box-shadow: 0 0 0 1px gray;
        content: "";
        background-image: url(${checkedIconGrey});
        background-size: 80% 80%;
        background-repeat: no-repeat;
        background-position: center;
    }

    & + span {
        font-size: 12px;
        color: #707070 !important;
        margin-left: 16px;
        display: block;
        margin-top: -4px;
        margin-bottom: 16px;
    }
`;

export const MailSendedWrapper = styled.div`
    text-align: center;

    p {
        max-width: 70%;
        margin: 0 auto;
        color: var(--primary) !important;
        font-size: 16px;
    }
`;